/**
 * The data trenching application's own routes, mounted by the shell at /trenching.
 *
 * Nothing in here knows it sits at /trenching — the prefix is the shell's decision, recorded
 * once in `platform/registry.ts`.
 */
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const EngagementsPage = lazy(() => import('@/apps/trenching/EngagementsPage'));
const EngagementNewPage = lazy(() => import('@/apps/trenching/EngagementNewPage'));
const EngagementDetailPage = lazy(() => import('@/apps/trenching/EngagementDetailPage'));
const TemplatesPage = lazy(() => import('@/apps/trenching/TemplatesPage'));
const TemplateNewPage = lazy(() => import('@/apps/trenching/TemplateNewPage'));

export const trenchingRoutes = (
  <Route path="trenching">
    <Route index element={<EngagementsPage />} />
    <Route path="engagements/new" element={<EngagementNewPage />} />
    <Route path="engagements/:engagementId" element={<EngagementDetailPage />} />
    <Route path="templates" element={<TemplatesPage />} />
    <Route path="templates/new" element={<TemplateNewPage />} />
  </Route>
);
